import { render, staticRenderFns } from "./DettaglioImmobileView.vue?vue&type=template&id=7df55680&scoped=true&"
import script from "./DettaglioImmobileView.vue?vue&type=script&lang=js&"
export * from "./DettaglioImmobileView.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioImmobileView.vue?vue&type=style&index=0&id=7df55680&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df55680",
  null
  
)

export default component.exports